import { render, staticRenderFns } from "./ReminderList.vue?vue&type=template&id=d2cd20ca&scoped=true&"
import script from "./ReminderList.vue?vue&type=script&lang=js&"
export * from "./ReminderList.vue?vue&type=script&lang=js&"
import style0 from "./ReminderList.vue?vue&type=style&index=0&id=d2cd20ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2cd20ca",
  null
  
)

export default component.exports